import { render, staticRenderFns } from "./NoteInfoFold.vue?vue&type=template&id=358318c0&scoped=true"
import script from "./NoteInfoFold.vue?vue&type=script&lang=js"
export * from "./NoteInfoFold.vue?vue&type=script&lang=js"
import style0 from "./NoteInfoFold.vue?vue&type=style&index=0&id=358318c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358318c0",
  null
  
)

export default component.exports